export default __webpack_public_path__ + "static/media/dashboard.90b57518.svg";